import { Button, Grid, GridItem, Textarea, useToast } from "@chakra-ui/react";
import { HeadingPages } from "../../../components/HeadingPages";
import { Layout } from "../../../components/Layout";
import InputFloating from "../../../components/InputFloating";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { user } from "../../../helpers/user";
import { useMutation } from "react-query";
import { api } from "../../../services/api";

const schema = yup.object().shape({
  nome: yup.string().required("Nome do Vendedor é obrigatório"),
  valor: yup.string().required("Valor do Desconto é obrigatório"),
  pedido: yup.string().required("Número do pedido é obrigatório"),
  observacao: yup.string().required("Observação é obrigatório"),
});

export function DescontoVendedor() {
  const { handleSubmit, register, formState, reset } = useForm({
    resolver: yupResolver(schema),
  })

  const toast = useToast({
    position: "top-right",
    duration: 3000,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationKey: "descontoVendedor",
    async mutationFn(data) {
      const response = await api.post('/site/v2/pedido/descontar-vendedor', data)

      return response.data
    },
    onSuccess() {
      console.log("sucesso")
      toast({
        title: "Desconto Vendedor",
        description: "Desconto Vendedor aplicado com sucesso!",
        status: "success",
      })

      reset()

    },
    onError(error) {
      console.log(error)
      toast({
        title: "Desconto Vendedor",
        description: "Erro ao aplicar Desconto Vendedor!",
        status: "error",
      })
    }
  })

  async function handleDescontoVendedor(data) {
    const { nome, valor, pedido, observacao, user_id } = data

    try {
      await mutateAsync({
        nome_usuario_desconto: nome,
        valor_desconto: valor,
        ad_numinno: pedido,
        descricao_usuario: observacao,
        codigo_usuario: user_id
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <HeadingPages name="Desconto Vendedor" />

      <Layout>
        <Grid templateColumns="repeat(2, 1fr)" gap={4} maxW={"800px"} mx="auto"
          as="form" onSubmit={handleSubmit(handleDescontoVendedor)}
        >
          <GridItem>
            <InputFloating label="Nome do Vendedor" 
              {...register("nome")}
              error={formState.errors.nome}
            />
          </GridItem>
          <GridItem>
            <InputFloating label="Valor do Desconto" 
              {...register("valor")}
              error={formState.errors.valor}
            />
          </GridItem>
          <GridItem>
            <InputFloating label="Número do pedido" 
              {...register("pedido")}
              error={formState.errors.pedido}
            />
          </GridItem>
          <GridItem colSpan={2}>
            <Textarea placeholder="Observação" resize="none" 
              {...register("observacao")}
              error={formState.errors.observacao}
            />
          </GridItem>
          <input type="hidden" {...register("user_id")} value={user?.codigo_usuario} />

          <GridItem
            colSpan={2}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Button 
              colorScheme="blue"
              isLoading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              Salvar
            </Button>
          </GridItem>
        </Grid>
      </Layout>
    </>
  )
}